import React, { useState } from "react";
import AppSecond from "./secondPage";
import axios from "axios";
import { API_URL } from "./apiURL";
function App() {
  // React States
  const [errorMessages, setErrorMessages] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [token, setToken] = useState("");
  // User Login info
  const database = [
    {
      username: "mbhagoli",
      password: "pwd12345"
    },
    {
      username: "imran",
      password: "accounts"
    },
    {
      username: "rajat",
      password: "password"
    },
    {
      username: "admin",
      password: "adminPassword"
    }

  ];

  const errors = {
    uname: "invalid username",
    pass: "invalid password"
  };

  const handleSubmit = (event) => {
    //Prevent page reload
    event.preventDefault();

    var { uname, pass } = document.forms[0];

    // Find user login info
    const userData = database.find((user) => user.username === uname.value);
    // Compare user info
    if (userData) {
      if (userData.password !== pass.value) {
        // Invalid password
        setErrorMessages({ name: "pass", message: errors.pass });
      } else {
        var data = JSON.stringify({
          "username": "rajat",
          "password": "password",
          "device_id": "12345"
        });
        localStorage.setItem("alerting system",false);
        var config = {
          method: 'post',
        maxBodyLength: Infinity,
          //url: 'http://cloud.indradhanush.com:5555/users/authenticate',
          url: `${API_URL}/users/authenticate`,
          headers: { 
            'Content-Type': 'application/json'
          },
          data : data
        };
        
        axios(config)
        .then(function (response) {
          setToken(response.data.user.token)
          localStorage.setItem("token",response.data.user.token)          
          
        })
        .catch(function (error) {
          console.log(error);
        });
        setIsSubmitted(true);
        
      }
    } else {
      // Username not found
      setErrorMessages({ name: "uname", message: errors.uname });
    }
    
  };

  // Generate JSX code for error message
  const renderErrorMessage = (name) =>
    name === errorMessages.name && (
      <div className="error">{errorMessages.message}</div>
    );

  // JSX code for login form
  const renderForm = (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <div className="input-container">
          <label>Username </label>
          <input type="text" name="uname" required />
          {renderErrorMessage("uname")}
        </div>
        <div className="input-container">
          <label>Password </label>
          <input type="password" name="pass" required />
          {renderErrorMessage("pass")}
        </div>
        <div className="button-container">
          <input type="submit" />
        </div>
      </form>
    </div>
  );

  return (
    <div className="app">
      <div className="login-form">
        {isSubmitted ? <div className="second"><AppSecond /></div> : renderForm}
      </div>
    </div>
  );
}

export default App;